/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./upload-image.vue?vue&type=template&id=5240c57e&scoped=true&"
import script from "./upload-image.vue?vue&type=script&lang=ts&"
export * from "./upload-image.vue?vue&type=script&lang=ts&"
import style0 from "./upload-image.vue?vue&type=style&index=0&id=5240c57e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5240c57e",
  null
  
)

export default component.exports